/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum HouseType {
  House = 'HOUSE',
  Outside = 'OUTSIDE'
}
